import styled from "styled-components";

const HomeTableWrap = styled.div`
  padding: 32px 0;
  @media(max-width: 768px) {
    padding: 32px 0;
  }
`

export default HomeTableWrap